/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import { Loyalty, Plan, Price } from '@/api/products';
import { GenericObject, GuardFunction } from './types';

export const isString = (val: unknown): val is string =>
  typeof val === 'string';
export const { isArray } = Array;
export const isFunction = (val: unknown): val is GuardFunction =>
  typeof val === 'function';

export const isUndef = (val: unknown): val is undefined =>
  typeof val === 'undefined';

export const isServer = () => typeof window === 'undefined';
export const isClient = () => typeof window !== 'undefined';

export const getError = (errors: GenericObject, fields: string) => {
  let error = errors;
  const dotFields = fields?.split('.') || [];

  dotFields.forEach((field) => {
    if (error && field in error) {
      error = error[field];
    }
  });

  return error?.message;
};

export const getOnlyNumbers = (value: string) => value?.replace(/\D/g, '');
export const getFidelityByDDD = (fidelidades: Loyalty[], ddd: string) => {
  const fidelity = fidelidades.find((fidelidade) => {
    return fidelidade.precos.find((preco) => preco.ddd === String(ddd));
  });
  return fidelity;
};

export const getFidelityValueByDDD = (fidelidade: Loyalty, ddd: string) => {
  const fidelity = fidelidade.precos.find((preco) => preco.ddd === String(ddd));
  return fidelity?.preco_atual || 0;
};

export const getPriceBaseByDDD = (precos?: Price[], ddd?: string) => {
  const preco = precos?.find((value) => {
    return value.ddd === String(ddd);
  });

  return preco ? preco.preco_atual : Number(precos && precos[0].preco_atual);
};

// Reordena fidelidades (e seus precos) para que as do DDD do cliente venham
// primeiro — o restante do app le sempre fidelidades[0].precos[0].
export const sortFidelitiesByDDD = (fidelities: Loyalty[], ddd: string) => {
  const fidelitiesFormated = fidelities.map((fidelity: Loyalty) => ({
    ...fidelity,
    precos: [
      ...fidelity.precos.filter((price) => price.ddd === ddd),
      ...fidelity.precos.filter((price) => price.ddd !== ddd),
    ],
  }));
  return [
    ...fidelitiesFormated.filter(
      (fidelity) => !!fidelity.precos.find((price) => price.ddd === ddd)
    ),
    ...fidelitiesFormated.filter(
      (fidelity) => !!fidelity.precos.find((price) => price.ddd !== ddd)
    ),
  ];
};

// Localiza o plano correspondente (CONTROLE <-> EXPRESS) que pode ser vendido
// para o DDD do cliente. `correspondente` apontar para um tim_id NAO garante
// que ele esteja ativo em /core/planos nem que tenha preco para o DDD — em
// producao existem planos cujo correspondente esta inativo. Retorna undefined
// nesses casos para o chamador nao oferecer a troca de forma de pagamento.
export const findCorrespondentByDDD = (
  products: Plan[] | undefined,
  correspondente: string | null | undefined,
  ddd: string
): Plan | undefined => {
  if (!products || !correspondente) {
    return undefined;
  }

  const found = products.find(
    (plan) =>
      plan.tim_id === correspondente &&
      plan.precos.some((price) => price.ddd === ddd)
  );

  if (!found) {
    return undefined;
  }

  return {
    ...found,
    fidelidades: sortFidelitiesByDDD(found.fidelidades, ddd),
  };
};

export const convertBRToUSDate = (brDate: string) => {
  // Convert 01/02/1990 to 1990-02-01
  return brDate.split('/').reverse().join('-');
};

export const formatZipCode = (zipCode: string) => {
  return zipCode.replace(/(\d{5})(\d{3})/, '$1-$2');
};
